import React, { useState } from "react";
import { getCookie, parseDob, canUploadKyc } from "../../../Helpers/Utils";
import { useDispatch, useSelector } from "react-redux";
import White from "../../../Assets/images/white-bg.avif"
import Modal from "../../../Helpers/Components/Modal";
import DatePicker from "react-multi-date-picker";
import { setCustomer, setDl, setStep } from "../../../Reducer/customerSlice";
import { toast } from "react-toastify";
import Compressor from 'compressorjs';
import moment from "moment";
import Handler from "../../../Helpers/Components/Handler";
import NextPrev from "../../../Helpers/Components/NextPrev";

const DL = (props) => {
    const person = getCookie('person')
    const dl = useSelector(state => state?.customer?.dl)
    const customer = useSelector(state => state?.customer?.customer)
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const checkFileSize = (file, fieldName, previewKey) => {
        if (file.size > 4.5 * 1024 * 1024) {
            toast.error('Compressed image size exceeds 4.5 MB.');
        } else {
            dispatch(setDl({ [fieldName]: file, [`${previewKey}`]: URL.createObjectURL(file) }));
        }
    };
    const compressImage = (file, fieldName, previewKey) => {
        new Compressor(file, {
            quality: 0.9,
            convertSize: 1 * 1024 * 1024,
            success(result) {
                checkFileSize(result, fieldName, previewKey);
            },
            error(err) {
                toast.error(err.message);
            },
        });
    };
    const handleImage = (event, previewKey) => {
        if (event.target.files[0]) {
            compressImage(event.target.files[0], [event.target.name], previewKey);
        }
    };
    const verifyDl = async () => {
        if (!dl?.dl) {
            toast.error("Driving license is required")
        } else if (!dl?.dl_photo) {
            toast.error("Driving license Photo is required")
        } else if (!dl?.dl_back_photo) {
            toast.error("Front and back Driving license Photo is required")
        } else if (!customer?.dob) {
            toast.error("Select the customer DOB")
        } else {
            setLoading(true)
            const formData = new FormData();
            formData?.append("dl", dl?.dl);
            formData.append("dob", customer?.dob ? moment(new Date(customer?.dob))?.format("DD-MM-YYYY") : moment(new Date(new Date()?.setFullYear(new Date()?.getFullYear() - 18)))?.format("DD-MM-YYYY"))
            formData.append('dl_photo', dl?.dl_photo);
            formData.append('dl_back_photo', dl?.dl_back_photo);
            const response = await Handler({ method: "patch", data: formData, url: `/customer/details/dl/verify/${props?.customerId}`, headers: { 'Content-Type': 'multipart/form-data' } })
            if (response?.success) {
                if (response?.data?.exist) {
                    toast.error(response?.message)
                }
                toast.success("DL Verified")
                dispatch(setDl({ dlStatus: true, detail: { dob: response?.data?.dob }, dlDate: response?.data?.dlDate, dlName: response?.data?.name, dl_photo: response?.data?.dl_photo, dl_back_photo: response?.data?.dl_back_photo }))
            } else {
                toast.error(response?.message)
            }
            setLoading(false)
        }
    }
    const handleNext = async () => {
        if (!dl?.dl && customer?.type === "Online") {
            toast.error("Driving license is required");
        } else if (!dl?.dl_photo && customer?.type === "Online") {
            toast.error("Driving license Photo is required");
        } else if (!dl?.dl_back_photo && customer?.type === "Online") {
            toast.error("Driving license Back Photo is required");
        } else if (!dl?.dlStatus && customer?.type === "Online") {
            toast.error("Verify Your Driving License")
        } else {
            if ((dl?.dl || dl?.dl_photo || dl?.dl_back_photo) && (!dl?.dlStatus || (dl?.dl_photo && typeof dl?.dl_photo !== "string") || (dl?.dl_back_photo && typeof dl?.dl_back_photo !== "string"))) {
                setLoading(true);
                const formData = new FormData();
                dl?.dl && formData.append('dl', dl?.dl);
                dl?.dlDate && formData.append('dlDate', moment(new Date(dl?.dlDate))?.format("DD/MM/YYYY"))
                dl?.dl_photo && formData.append('dl_photo', dl?.dl_photo);
                dl?.dl_back_photo && formData.append('dl_back_photo', dl?.dl_back_photo);
                customer?.dob && formData?.append('dob', customer?.dob ? moment(new Date(customer?.dob))?.format("DD/MM/YYYY") : moment(new Date(new Date()?.setFullYear(new Date()?.getFullYear() - 18)))?.format("DD/MM/YYYY"))
                const response = await Handler({ method: "patch", url: `/customer/details/fourth/update/${props?.customerId}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
                if (response?.success) {
                    if (response?.data?.exist) {
                        toast.error(response?.message)
                    }
                    if (dl?.dlDate && new Date(dl?.dlDate) <= new Date()) {
                        toast.error("DL is expired")
                    }
                    dispatch(setDl({ ...(response?.data?.dl_photo ? { dl_photo: response?.data?.dl_photo } : {}), ...(response?.data?.dl_back_photo ? { dl_back_photo: response?.data?.dl_back_photo } : {}) }))
                    dispatch(setStep(4))
                } else {
                    toast.error(response?.message);
                }
                setLoading(false)
            } else {
                dispatch(setStep(4))
            }
        }

    }
    const setSteps = () => {
        dispatch(setStep(2))
    }
    return (
        <React.Fragment>
            <div className="row">
                <div className="col-md-6 col-xl-4">
                    <div className="form-label mb-3">DL Photo</div>
                    <div className="main-div mt-3">
                        <div className="btn-div">
                            {canUploadKyc(person, dl?.dlStatus, dl?.dl_photo) ? <label htmlFor="dl_photo" className="me-2 upload-btn">Upload</label> : ""}
                            <button className="btn-warning btn btn-sm" onClick={() => { if (dl?.dlPhoto) { props?.setChosen(dl?.dlPhoto); props?.setProof(true) } }}>View</button>
                        </div>
                        <input type="file" accept="image/*" className="d-none" name="dl_photo" id="dl_photo" onChange={(e) => handleImage(e, "dlPhoto")} disabled={loading} />
                        <img src={dl?.dlPhoto || White} alt="Driving License" className="kycPhotoImg" />
                    </div>
                    <div className="main-div mt-3">
                        <div className="btn-div">
                            {canUploadKyc(person, dl?.dlStatus, dl?.dl_back_photo) ? <label htmlFor="dl_back_photo" className="me-2 upload-btn">Upload</label> : ""}
                            <button className="btn-warning btn btn-sm" onClick={() => { if (dl?.dlBackPhoto) { props?.setChosen(dl?.dlBackPhoto); props?.setProof(true) } }}>View</button>
                        </div>
                        <input type="file" accept="image/*" className="d-none" name="dl_back_photo" id="dl_back_photo" onChange={(e) => handleImage(e, "dlBackPhoto")} disabled={loading} />
                        <img src={dl?.dlBackPhoto || White} alt="Driving License" className="kycPhotoImg" />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="dl" className="form-label"> DL No </label>
                        <div className="input-group mb-3">
                            <input autoComplete="off" maxLength={16} disabled={loading || dl?.dlStatus} id="dl" type="text" name="dl" value={dl?.dl || ""} onChange={(event) => { dispatch(setDl({ dl: event.target.value })) }} className="form-control input-theme text-uppercase" />
                            {dl?.dlStatus ? <span className="input-group-text" id="basic-addon2"><i className="fa-solid fa-circle-check" style={{ color: 'green' }}></i></span> : ""}
                        </div>
                    </div>
                    {
                        dl?.dlName ?
                            <div className="d-xl-none d-block mb-3">
                                <div className="mb-3">
                                    <label htmlFor="dlName" className="form-label"> DL Name </label>
                                    <input autoComplete="off" disabled id="dlName" type="text" name="dlName" value={dl?.dlName || ""} className="form-control input-theme text-uppercase" />
                                </div>
                            </div> : ""
                    }
                    <div className="mb-3">
                        <label htmlFor="dlDate" className="form-label"> DL Valid Upto </label>
                        <div className=" datepicker-top">
                            <DatePicker
                                className="input-theme"
                                value={dl?.dlDate ? new Date(dl?.dlDate) : undefined}
                                onChange={(e) => { dispatch(setDl({ dlDate: e ? new Date(e) : "" })) }}
                                format="DD-MM-YYYY"
                                minDate={new Date(new Date()?.setDate(new Date()?.getDate() + 1))}
                                disabled={loading || dl?.dlStatus || customer?.type === "Online"}
                                onOpenPickNewDate={false}
                            />
                        </div>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="dob" className="form-label"> DOB </label>
                        <div className=" datepicker-top">
                            <DatePicker
                                className="input-theme"
                                value={dl?.dlStatus ? (parseDob(dl?.detail?.dob) || "") :
                                    (dl?.dob && new Date(dl?.dob) !== "Invalid Date" ? new Date(dl?.dob) : (customer?.dob ? new Date(customer?.dob) : ""))
                                }
                                placeholder="Select DOB"
                                onChange={(e) => { dispatch(setCustomer({ dob: new Date(e) })) }}
                                format="DD-MM-YYYY"
                                disabled={loading || dl?.dlStatus}
                                maxDate={new Date()?.setFullYear(new Date()?.getFullYear() - 18)}
                                onOpenPickNewDate={false}
                            />
                        </div>
                    </div>
                    {
                        !dl?.dlStatus ? <button className="btn btn-sm btn-success" disabled={loading} onClick={verifyDl}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Verify"}</button> : ""
                    }
                    {
                        dl?.dlStatus && person === "admin" ? <button className="btn btn-sm btn-success" disabled={loading} onClick={() => { dispatch(setDl({ dlStatus: false })) }}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Update"}</button> : ""
                    }
                </div>
                {
                    dl?.dlName ?
                        <div className="d-xl-block d-none col-xl-4">
                            <div className="mb-3">
                                <label htmlFor="dlName" className="form-label"> DL Name </label>
                                <input autoComplete="off" maxLength={16} disabled id="dlName" type="text" name="dlName" value={dl?.dlName || ""} className="form-control input-theme text-uppercase" />
                            </div>
                        </div>
                        : ""
                }
            </div>
            <NextPrev step={3} setStep={setSteps} last={7} onClick={handleNext} loading={loading} />
        </React.Fragment>
    )
}

export default DL;